module.exports = __webpack_public_path__ + "static/media/contracts_epargn.5eda5093.svg";